import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

import logoIcon from '../../Icons/Logos/qf-logo.png'

export const LOCDiv = styled(BaseStyles.Div)`
    padding: 2rem;
    width:  100vw;
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const LOCComponentsDiv = styled(BaseStyles.Div)`
    box-shadow:
        0 0px 3.8px rgba(0, 0, 0, 0.022),
        0 0px 8.3px rgba(0, 0, 0, 0.031),
        0 0px 14.9px rgba(0, 0, 0, 0.039),
        0 0px 30.5px rgba(0, 0, 0, 0.048),
        0 0px 104px rgba(0, 0, 0, 0.07)
    ;
    margin: auto;
    flex: 1 1 50rem;
    min-width: 30rem;
    max-width: 50rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.8rem;
    background-color: white;
    padding: 0.75%;
`
export const LOCContentsDiv = styled(BaseStyles.Div)`
    padding: 6rem 2rem;
    width: 100%;
`

export const QuickFillerButtonDiv = styled(BaseStyles.Div)`
    margin-bottom: 7.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const TitleIconButton = styled(BaseStyles.IconButton)`
    margin-right: 0.5rem;
    padding: 0;
    width: 3rem;
    height: 3rem;
    background-image: url(${logoIcon});
    cursor: pointer;
`

export const QuickFillerButton = styled.button`
    margin: 0;
    padding: 0;
    color: black;
    background-color: transparent;
    outline-style: none;
    cursor: pointer;
    font-size: 3rem;
    border: none;
    font-weight: bold;
    font-family: "Helvetica Neue";
    &:hover {
        color: #4267B2;
    }
`

export const LOCTitle = styled.h2`  
    margin: 0;
    padding: 0rem;
    padding-bottom: 7.5rem;
    font-size: 2.5rem;
    font-weight: 550;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
`

export const LOCPhraseDiv = styled(BaseStyles.Div)`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const LOCPhrase = styled.p`
    display: inline;
    margin: 0;
    padding: 0;
    font-size: 1.4rem;
    font-weight: normal;
`

export const HereLink = styled.a`
    margin: 0;
    padding: 0;
    color: black;
    font-size: 1.4rem;
`